export default __webpack_public_path__ + "static/media/logo-petlover.cf8b6b44.png";